import {Routes} from "@angular/router";

enum Paths {
    EMPTY = "",
    STATION_LIST = "station-list",
    STATION_INFO = "station-list/station/:id",
    ERROR_CODES = "error-codes/manager"
}

const StationConsoleListComponent = () => import("@pages/console/ui/station-console-list/station-console-list.component").then(m => m.StationConsoleListComponent);
const StationConsoleInfoComponent = () => import("@pages/console/ui/station-console-info/station-console-info.component").then(m => m.StationConsoleInfoComponent);
const ErrorCodesManagerComponent = () => import("@pages/console/ui/error-codes-manager/error-codes-manager.component").then(m => m.ErrorCodesManagerComponent);

export const consoleRoutes: Routes = [
    {
        path: Paths.EMPTY,
        redirectTo: "station-list",
        pathMatch: "full"
    },
    {
        path: Paths.STATION_LIST,
        loadComponent: StationConsoleListComponent
    },
    {
        path: Paths.STATION_INFO,
        loadComponent: StationConsoleInfoComponent
    },
    {
        path: Paths.ERROR_CODES,
        loadComponent: ErrorCodesManagerComponent
    }
];
